import React, { useState } from 'react';
import style from './InsiderTrades.module.css';
import TabButtons from '../TabButtons/TabButtons';
import InsiderTradesTab from './InsiderTradesTab';
import CongressTradesTab from './CongressTradesTab';

const InsiderTrades = ({ stock, current_user }) => {
  const [value, setValue] = useState(1);

  return (
    <div>
      <h3 className={style.headline}>
        {value === 1 ? 'Insider Trades' : 'Congress Trades'}
      </h3>
      <TabButtons className={style.tabs}>
        <TabButtons.Tab onClick={() => setValue(1)} active={value === 1}>
          Insider
        </TabButtons.Tab>
        <TabButtons.Tab onClick={() => setValue(2)} active={value === 2}>
          Congress
        </TabButtons.Tab>
      </TabButtons>
      {
        value === 1 ? <InsiderTradesTab stock={stock} /> : <CongressTradesTab stock={stock} current_user={current_user} />
      }
    </div>
  );
};

export default InsiderTrades;


